import { AfterContentInit, AfterViewInit, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MembersPortalService } from '../../../angular-wallet-base/services/members-portal.service';
import { AlertController, ModalController, NavController, ToastController, Platform, ViewDidEnter } from '@ionic/angular';
import { UpdatePasswordPage } from '../../update-password/update-password.page';
import { TranslateService } from '@ngx-translate/core';
import { Enable2faComponent } from '../enable2fa/enable2fa.component';
import { USER_PREFERENCES_STORAGE_KEY, AUTH_REASON, MAX_GAS_LIMIT_TO_SEND, MAX_GWEI_TO_SEND, PREVENT_2FA_REAUTH_TIMEOUT, WALLET_STORAGE_KEY } from '../../../angular-wallet-base/constants';
import { Router, NavigationEnd, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { getSetupMnemonic } from '../../../angular-wallet-base/store/setup';
import { List2faDeviceComponent } from '../list2fa-device/list2fa-device.component';
import { openKYC } from 'src/app/angular-wallet-base/utils';
import { Subscription } from 'rxjs';
import { getServiceStatus } from 'src/app/angular-wallet-base/store/connection';
import { confirmResetWalletAlert, presentAlert } from 'src/app/angular-wallet-base/utils';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { ServiceCheckerService } from 'src/app/angular-wallet-base/services/service-check.service';
import { StorageService } from 'src/app/angular-wallet-base/services/storage.service';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { getSideMenuStatus } from 'src/app/angular-wallet-base/store/appSettings';
import { environment } from '../../../../environments/environment';
import { BiometricAuthService } from '../../../angular-wallet-base/services/biometric-auth.service';
import { BankAccountService } from '../../../angular-wallet-base/services/bank-account.service';
import { AlertOptions } from '@ionic/core';
import { AuthService } from 'src/app/angular-wallet-base/services/auth.service';
import { ComplianceService } from '../../../angular-wallet-base/services/compliance.service';

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss'],
})
export class SecurityComponent implements OnInit, AfterContentInit, AfterViewInit {
  @Input('phrase') phrase: any;
  public kycData: any = {};
  public is2FAEnabled;
  public lodeUser;
  public shouldShowChangePin: boolean = false;
  public phraseArray: string[];
  public devices: any = [];
  public services;
  protected subscriptions = new Subscription();
  public showWalletInfo: boolean = false;
  public isDesktopMode: boolean;
  public loadingSpinner: boolean = false;
  public isBauthEnabled = environment.features.bauth;
  public isBiometricAvailable: boolean = false;
  public isBiometricActive: boolean = false;
  public loadingSpinner1: boolean = false;
  public isKycSynced: boolean = false;
  public ptKycData: any = {};
  public last_updated = null;
  public loader = false;

  constructor(
    private membersPortalService: MembersPortalService,
    private complianceService: ComplianceService,
    private checkerServices: ServiceCheckerService,
    private modalController: ModalController,
    private nav: NavController,
    private modal: ModalController,
    private alertController: AlertController,
    private storage: StorageService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public store: Store<AppState>,
    private translate: TranslateService,
    public appMode: AppModeService,
    private toast: ToastController,
    private platform: Platform,
    private bauth: BiometricAuthService,
    private bankAccountService: BankAccountService,
  ) {
    this.loadingSpinner = true;
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
    // Update services status
    this.checkerServices.updateAllServices();
    this.kycData['passingLevel'] = false;
    this.setKycData();
    this.subscriptions.add(this.store.select(getServiceStatus).subscribe(data => {
      this.services = data;
    }));
  }
  async ngAfterViewInit() {
    await this.setSettingsState();
  }

  async ngOnInit() {
    this.loader = true;
    try {
      this.lodeUser = await this.membersPortalService.getUserInfo();
      this.is2FAEnabled = this.lodeUser.two_factor;
    } catch (error) {
      Logger.error('userInfo',error);
    }

    this.devices = await this.membersPortalService.getUserDevices();

    // check wallet info
    this.showWalletInfo = (await this.storage.get(WALLET_STORAGE_KEY)) ? true : false;
    this.loader = false;
    
    // check Biometric Authentication
    this.isBiometricAvailable = await this.bauth.isAvailable();
    await this.updateIonToggle();
    this.checkPTKycSync();
  }

  async setKycData() {
    try {
      this.kycData = await this.complianceService.getKycCip();
      this.loadingSpinner = false;
    } catch (error) {
      Logger.error('compliance kyc error',error);
      this.loadingSpinner = false;
    }
  }

  async updateIonToggle() {
    this.isBiometricActive = await this.bauth.isActive();
  }

  async toggleBiometric() {
    const isBiometricActive = await this.bauth.isActive();

    if (isBiometricActive) {
      return await this.authService.openAuthPinModal(AUTH_REASON.DEACTIVATE_BIOMETRIC);
    }
    await this.authService.openAuthPinModal(AUTH_REASON.ACTIVATE_BIOMETRIC);

  }

  async showUpdatePassword() {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();

    let cssClass = '';
    cssClass += (this.isDesktopMode) ? 'update-password-modal-desktop' : 'update-password-modal';
    cssClass += (!sideMenuHidden && this.isDesktopMode) ? ' with-side-menu' : '';

    const modal = await this.modalController.create({
      component: UpdatePasswordPage,
      cssClass
    });
    await modal.present();
  }

  async enableDisable2FA() {
    const modal = await this.modalController.create({
      component: Enable2faComponent,
      cssClass: this.isDesktopMode ? 'twofa-model-des-css' : 'twofa-model-mob-css',
    });

    modal.onDidDismiss()
      .then((res) => {
        if (res.data == undefined || res.data.status == undefined)
          this.is2FAEnabled = this.is2FAEnabled;
        else this.is2FAEnabled = res.data.status;
      });

    await modal.present();
  }
  
  async syncPTKYC() {
    this.loadingSpinner1 = true;
    try {
      const test = await this.bankAccountService.uploadPTKycDoc();
      Logger.info(test)
      this.checkPTKycSync();
      presentAlert(this.alertController, this.translate, null, 'settings.toast_msgs.ok_hdr', 'settings.billing.kyc_synced_message', 'btn_ok');
      this.loadingSpinner1 = false;
    } catch (e) {
      Logger.error('uploadPTKycDoc',e);
      presentAlert(this.alertController, this.translate, null, 'settings.toast_msgs.err_hdr', 'settings.billing.kyc_failed_synced_message', 'btn_ok');
      this.isKycSynced = false;
      this.loadingSpinner1 = false;
    }
  }

  async checkPTKycSync() {
    try {
      await this.bankAccountService.getPTKycSyncStatus();
      this.isKycSynced = true;
    } catch (e) {
      Logger.error('getPTKycSyncStatus',e);
      this.isKycSynced = false;
    }
  }

  async presentAlert(opts: AlertOptions) {
    if (!opts.buttons) {
      Object.assign(opts, {
        buttons: ['Ok']
      });
    }
    const alert = await this.alertController.create(opts);
    alert.present();
  }

  async checkPTKycApproval() {
    try {
      this.ptKycData = await this.bankAccountService.getPTKycApproveStatus();
      this.last_updated = this.ptKycData.last_updated;
      Logger.info(this.ptKycData);
      this.bankAccountService.showKYCStatus(JSON.parse(this.ptKycData));
    } catch (e) {
      Logger.error('getPTKycApproveStatus',e);
      if (e.status === 422) {
        this.bankAccountService.showKYCStatus(JSON.parse(e.error));
      }
    }
  }
  async switchViewDeviceList() {
    const modal = await this.modalController.create({
      component: List2faDeviceComponent,
      cssClass: 'twofa-deviceList'
    });
    await modal.present();
  }

  async showRecoveryPhrase() {
    await this.authService.openAuthPinModal(AUTH_REASON.SHOW_RECOVERY_PHRASE);
  }

  async setSettingsState() {
    if (this.phrase) {
      this.phraseArray = this.phrase.split(' ');
    }
  }

  async hideRecoveryPhrase() {
    this.authService.setRecoveryPhrase(null);
    this.phraseArray = null;
    this.phrase = null;
  }

  async ngAfterContentInit() {
    this.setSettingsState();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setSettingsState();
  }

  async changeWalletPin() {
    await this.authService.openAuthPinModal(AUTH_REASON.CHANGE_PIN);
  }
  
  async openKYCModal() {
    this.loadingSpinner = true;
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    let cssClass = '';
    cssClass += (this.isDesktopMode) ? 'kyc-modal-desktop' : 'kyc-modal';
    await openKYC(
      this.loadingSpinner,
      this.complianceService,
      this.translate,
      this.toast,
      this.modalController,
      this.platform, cssClass
    );
    this.loadingSpinner = false;
  }

  memberPortalIsAvailable() {
    Logger.info(this.services);
    if (this.services) {
      return this.services.memberPortal;
    }
    return true;
  }

  async confirmReset() {
    const handler = async (data) => {
      await this.authService.openAuthPinModal(AUTH_REASON.RESET_WALLET);
    };
    await confirmResetWalletAlert(this.alertController, this.translate, handler, true);
  }

}
